import { useChannelTalk } from '@repo/channel-talk';
import { useWorkingPlatform } from '@repo/platform';
import { PageViewEventLogger, useUserEventLogger } from '@repo/tracking-service';
import { useDialog } from '@repo/ui';
import { AuthGuard } from '@repo/user-session';
import cn from 'clsx';
import { useRouter } from 'next/router';
import { ReactElement, useState } from 'react';

import Layout from '@/components/layout/Layout';
import { SummaryModalProvider } from '@/components/tax-refund/common/context/SummaryModalProvider';
import SummaryContent from '@/components/tax-refund/summary/SummaryContent';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { COMMON_PATHS } from '@/lib/constants/paths';
import { TAX_REFUND_SUMMARY_PAGE_CATEGORY } from '@/lib/constants/summary';
import { useExitService } from '@/lib/hooks/use-exit-service';

const TaxRefundSummaryPage = () => {
  const { showDialog } = useDialog();
  const { sendClickEvent, sendViewEvent } = useUserEventLogger();
  const { workingPlatform } = useWorkingPlatform();
  const [existDataType, setExistDataType] = useState('checking');
  const { openChannelTalk } = useChannelTalk();
  const router = useRouter();
  const { exitService } = useExitService();
  const isUseCloseButton = workingPlatform === 'kbank';
  const handleClickSupport = () => {
    openChannelTalk(existDataType === 'none' || existDataType === 'checking' ? SUPPORT_BOT_LINK.개인법인선택 : SUPPORT_BOT_LINK.조회목록);
  };

  const handleClose = () => {
    sendViewEvent('home_dialog_close-dialog', undefined, { isAllowRetry: true });
    showDialog({
      title: '비즈넵 환급을 종료하시겠어요?',
      buttons: {
        primary: {
          text: '종료하기',
          onClick: () => {
            sendClickEvent('home_dialog_edk-close-ok');
            exitService();
          }
        },
        secondary: {
          text: '취소',
          onClick: () => {
            sendClickEvent('home_dialog_edk-close-retry');
          }
        }
      }
    });
  };

  const goMoreMenu = () => {
    router.push(COMMON_PATHS.MORE_MENU);
  };

  return (
    <AuthGuard>
      <Layout
        leftIcon={
          isUseCloseButton
            ? {
                icon: 'close',
                onClick: handleClose,
                clickEvent: {
                  name: 'home_topnav_close'
                }
              }
            : {
                icon: 'bznav-refund-logo',
                clickEvent: {
                  name: 'home_topnav_logo'
                }
              }
        }
        rightIcons={[
          {
            icon: 'consult',
            color: 'gray.800',
            onClick: handleClickSupport,
            clickEvent: {
              name: 'home_topnav_cx',
              attributes: {
                type: existDataType === 'none' ? 'before-lookup' : 'after-lookup'
              }
            }
          },
          {
            icon: 'more-vertical',
            color: 'gray.800',
            onClick: goMoreMenu,
            clickEvent: {
              name: 'home_topnav_more'
            }
          }
        ]}
        backgroundColor={'#F3F7F8'}
        className={cn({ ['min-h-screen']: existDataType === 'none' })}
        mainClassName={'!max-w-full'}
      >
        <SummaryModalProvider>
          <SummaryContent existDataType={existDataType} setExistDataType={setExistDataType} />
        </SummaryModalProvider>
      </Layout>
      <PageViewEventLogger pageName={TAX_REFUND_SUMMARY_PAGE_CATEGORY} />
    </AuthGuard>
  );
};

export default TaxRefundSummaryPage;

TaxRefundSummaryPage.getLayout = (page: ReactElement) => <>{page}</>;
